export function pinBackButton(elementId = "backButton"): (() => void) | undefined {
  const btn = document.getElementById(elementId);
  if (!btn || btn.dataset.pinned === "true") return undefined;

  const anchor = btn as HTMLElement;
  const parent = anchor.parentElement;
  if (!parent) return undefined;

  const computed = window.getComputedStyle(anchor);
  const spacer = document.createElement("div");
  spacer.className = "back-button-spacer";
  spacer.style.height = `${anchor.offsetHeight}px`;
  spacer.style.marginBottom = computed.marginBottom;
  parent.insertBefore(spacer, anchor);

  anchor.classList.add("back-button-fixed");

  const updatePosition = () => {
    const navbar = document.getElementById("navbar");
    const filterTab = document.getElementById("filter-tab");
    const navbarBottom = navbar
      ? navbar.getBoundingClientRect().bottom + 8
      : 8;

    if (filterTab) {
      const rect = filterTab.getBoundingClientRect();
      anchor.style.top = `${Math.max(navbarBottom, rect.top + 8)}px`;
      anchor.style.left = `${rect.left + 8}px`;
      anchor.style.setProperty(
        "width",
        `${Math.max(0, rect.width - 16)}px`,
        "important"
      );
      return;
    }

    const container =
      anchor.closest(".container") ||
      anchor.closest(".section-filter") ||
      parent;
    anchor.style.top = `${navbarBottom}px`;
    const rect = container.getBoundingClientRect();
    anchor.style.left = `${Math.max(12, rect.left)}px`;
    anchor.style.setProperty(
      "max-width",
      `${Math.max(0, rect.width)}px`,
      "important"
    );
  };

  const init = () => {
    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    anchor.dataset.pinned = "true";
  };

  if (anchor.offsetHeight === 0) {
    requestAnimationFrame(init);
  } else {
    init();
  }

  return () => {
    window.removeEventListener("resize", updatePosition);
    window.removeEventListener("scroll", updatePosition, true);
  };
}
